// removed by extract-text-webpack-plugin
module.exports = {"activity":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Activities-__Activities___2l3hH","symbol":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Activities-__Activities___14w2q"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrderDetail/Activities/Activities.css
// module id = 2133
// module chunks = 0